import { useCallback, useEffect } from 'react';

import { subscribeToEmergencyCallDetailsEvents } from './useEmergencyCallDetailsEventSubscriptions';

import { useAppDispatch } from 'features/app/hooks';
import { EmergencyCallDetailsStatus } from 'features/emergency/enums';
import { setEmergencyCallDetailsStatus } from 'features/emergency/store';
import { useWhileComponentMounted } from 'features/utils/hook';
import { VoiceMeetingEventBus } from 'features/voice-meeting/services';

export const useEmergencyCallDetailsParticipantHandler = () => {
  const whileComponentMounted = useWhileComponentMounted();
  const dispatch = useAppDispatch();

  const attendeePresenceDeclinedHandler = useCallback(() => {
    dispatch(
      setEmergencyCallDetailsStatus(EmergencyCallDetailsStatus.CALLEE_RECONNECT)
    );
  }, [dispatch]);

  useEffect(() => {
    const subscriptions = subscribeToEmergencyCallDetailsEvents(
      [
        {
          event$: VoiceMeetingEventBus.hearingCallDeclined$,
          handler: attendeePresenceDeclinedHandler,
        },
      ],
      whileComponentMounted
    );

    return () =>
      subscriptions.forEach((subscription) => subscription.unsubscribe());
  }, [attendeePresenceDeclinedHandler, whileComponentMounted]);
};
